import mixpanel from "mixpanel-browser";

const isMobileDevice = () => {
  return (
    /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    window.matchMedia("(max-width: 768px)").matches
  );
};

export const initMixpanel = () => {
  mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
    track_pageview: true,
    persistence: "localStorage"
  });

  mixpanel.register({
    device_type: isMobileDevice() ? "mobile" : "desktop"
  });
};

export const logUserToMixpanel = (userData) => {
  if (import.meta.env.VITE_ENVIRONMENT !== 'local') {
    if (userData && mixpanel.config) {
      mixpanel.identify(userData.id);
      mixpanel.people.set({
        $email: userData.email,
        $first_name: userData.first_name,
        $last_name: userData.last_name,
        user_id: userData.id,
      });
    }
  }
};

export default mixpanel;
